// for add employee
export const RESER_ADD_EMPLOYEE_SALARY = "reset_add_employee_salary";
export const ADD_EMPLOYEE_SALARY = "add_employee_salary";
export const ADD_EMPLOYEE_SALARY_SUCCESS = "add_employee_salary_success";
export const ADD_EMPLOYEE_SALARY_FAILURE = "add_employee_salary_failure";
